<template>
  <div>
    <Row type="flex" :space-x="10" class="margin-right-left padding-top">
      <Cell>
        <DatePicker type="year" v-model="year" format="YYYY" style="width: 130px"
                    placeholder="年度"></DatePicker>
      </Cell>
      <Cell>
        <Button color="primary" icon="fa fa-search" :loading="loading" @click="doSearch">查询</Button>
        <Button color="green" @click="markAll">全部标记已申报</Button>
        <Button @click="showTip('获取申报信息')">获取申报信息</Button>
        <Button @click="showTip('工商年报账号设置')">工商年报账号设置</Button>
      </Cell>
    </Row>
    <div class="h-panel-body padding-top">
      <Table :datas="dataList" :border="true" :loading="loading">
        <TableItem title="#" type="number" :width="60"></TableItem>
        <TableItem title="年度" prop="year" :width="120"></TableItem>
        <TableItem title="申报项目" prop="taxItem" :width="180"></TableItem>
        <TableItem title="申报状态" :width="120" align="center">
          <template slot-scope="{data}">
            <span class="h-tag" :class="data.declareStatus === 2 ? 'h-tag-bg-green' : 'h-tag-bg-yellow'">
              {{ data.declareStatus === 2 ? '已申报' : '未申报' }}
            </span>
          </template>
        </TableItem>
        <TableItem title="申报时间" prop="declareTime"></TableItem>
        <TableItem title="操作" :width="120">
          <div class="actions" slot-scope="{data}">
            <span @click="markDeclared(data)" v-if="data.declareStatus !== 2">标记已申报</span>
            <span v-else style="cursor: default;">已完成</span>
          </div>
        </TableItem>
      </Table>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'GsAnnual',
  data() {
    return {
      year: moment().format('YYYY'),
      dataList: [],
      loading: false
    }
  },
  methods: {
    showTip(name) {
      this.$Message(`「${name}」需要配置工商年报账号，请先完成账号配置~`);
    },
    loadList() {
      this.loading = true;
      this.$api.tax.declare.list({
        taxItem: '工商年报',
        year: this.year
      }).then(({data}) => {
        let list = data.results || data.records || data || [];
        this.dataList = list;
        //无数据时补一条当前年度的工商年报记录用于展示/标记
        if (!list.length) {
          this.dataList = [{
            id: null,
            taxItem: '工商年报',
            year: this.year,
            declareStatus: 0,
            declareTime: ''
          }];
        }
      }).catch(() => {
        this.dataList = [{
          id: null,
          taxItem: '工商年报',
          year: this.year,
          declareStatus: 0,
          declareTime: ''
        }];
      }).finally(() => this.loading = false);
    },
    doSearch() {
      this.loadList();
    },
    markDeclared(data) {
      this.$Confirm(`确认将 ${data.year} 年度工商年报标记为已申报？`).then(() => {
        this.loading = true;
        let params = Object.assign({}, data, {
          taxItem: '工商年报',
          year: this.year,
          declareStatus: 2,
          declareTime: moment().format('YYYY-MM-DD HH:mm')
        });
        this.$api.tax.declare[params.id ? 'update' : 'save'](params).then(() => {
          this.$Message('标记成功~');
          this.loadList();
        }).catch(() => {
          this.$Message.error('标记失败');
        }).finally(() => this.loading = false);
      });
    },
    markAll() {
      let pending = this.dataList.filter(item => item.declareStatus !== 2);
      if (!pending.length) {
        this.$Message('全部年度均已申报~');
        return;
      }
      this.markDeclared(pending[0]);
    }
  },
  mounted() {
    this.loadList();
  }
}
</script>
